<template>
    <v-dialog v-model="dialog" :max-width="typeIs('bracket') ? 1000 : 600">
        <v-card v-if="step === 1">
            <v-card-title class="headline grey lighten-2 justify-space-between" primary-title>
                Declare The Winner
                <v-btn icon @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text
                    v-if="typeIs('simple')
               || typeIs('pool')
               || typeIs('line')"
            >
                <v-list>
                    <v-item-group
                            v-model="contestantId"
                            active-class="yellow lighten-4"
                            mandatory>
                        <template v-for="i in instaplay.numContestants">

                            <v-item
                                    :key="i"
                                    :value="i"
                            >
                                <v-list-tile
                                        slot-scope="{ active, toggle }"
                                        :selected="active"
                                        @click="toggle"
                                        avatar
                                >
                                    <v-list-tile-avatar>
                                        <img :src="instaplay['contestant'+i].image">
                                    </v-list-tile-avatar>

                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="instaplay['contestant'+i].name"></v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-item>
                        </template>
                        <v-item :value="0">
                            <v-list-tile
                                    slot-scope="{ active, toggle }"
                                    :selected="active"
                                    @click="toggle"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title>Tie</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-item>
                    </v-item-group>
                </v-list>
            </v-card-text>

            <!--      <v-card-text-->
            <!--          v-if="typeIs('total')"-->
            <!--      >-->
            <!--        <v-subheader>Enter total for the contest:-->
            <!--        </v-subheader>-->
            <!--        <v-text-field-->
            <!--            label="total"-->
            <!--            v-model="totalPoints"-->
            <!--            class="px-3"-->
            <!--        ></v-text-field>-->
            <!--      </v-card-text>-->

            <v-card-text
                    v-if="typeIs('spread') || typeIs('total')"
            >
                <v-subheader>Enter the final score for each of the 2 contestants:
                </v-subheader>

                <v-list>

                    <template v-for="i in instaplay.numContestants">

                        <v-list-tile
                                :key="i"
                                avatar
                        >
                            <v-list-tile-avatar>
                                <img :src="instaplay['contestant'+i].image">
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-layout row align-center style="width: 100%">
                                    <v-list-tile-title v-html="instaplay['contestant'+i].name"
                                                       style="width: auto"></v-list-tile-title>
                                    <v-text-field
                                            label="final score"
                                            v-model.number="finalScore[i - 1]"
                                            type="number"
                                            class="px-3"
                                    ></v-text-field>
                                </v-layout>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>

            </v-card-text>

            <v-card-text
                    v-if="typeIs('bracket')"
            >
                <v-subheader>Fill the bracket:
                </v-subheader>
                <bracket-item :model="bracketModel" :teams="contestants" :all-teams="contestants" root>
                    <div class="text-xs-center font-weight-bold py-4">{{ instaplay.bracket.winnerLabel }}</div>
                </bracket-item>
                <v-checkbox label="Tie" v-model="bracketTie">
                </v-checkbox>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        round color="warning"
                        @click="submitWinner()"
                        :loading="isLoading('declare')"
                        :disabled="!valid"
                >
                    next
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="step === 2">
            <v-card-title
                    class="headline grey lighten-2 justify-space-between"
                    primary-title
            >
                {{typeIs('simple') ? 'Disperse SCoins' : 'Disperse The Prize'}}
                <v-btn icon @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="grey lighten-4">
                <div v-if="!typeIs('bracket')">
                    <div v-if="result.Message" class="px-2">
                        {{result.Message}}
                    </div>
                    <div v-if="result.winner" class="px-2">
                        Winner:
                        <span class="font-weight-bold text-capitalize">{{winner.w}}</span>
                        <v-avatar v-if="winner.i" :size="30" class="mx-2"><img :src="winner.i"></v-avatar>
                    </div>
                    <div v-else-if="winner" class="px-2">
                        <v-avatar v-if="winner.i2" :size="30" class="mx-2"><img :src="winner.i2"></v-avatar>
                        <span class="font-weight-bold text-capitalize">{{winner.w}}</span>
                        <v-avatar v-if="winner.i" :size="30" class="mx-2"><img :src="winner.i"></v-avatar>
                    </div>
                </div>
                <div v-if="result.GMdeltaSCoins" class="mt-2 pa-2 green white--text round">
                    SCoins returned to you:
                    <span class="font-weight-bold">{{result.GMdeltaSCoins}}</span>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-expansion-panel v-model="panel">
                    <v-expansion-panel-content
                            lazy class="black--text"
                            v-if="result.winnerList"
                            :disabled="!result.winnerList.length"
                            :key="0">
                        <template v-slot:header>
                            <div>Number of winners: {{result.winnerList.length}}</div>
                        </template>
                        <v-card>
                            <v-card-text>
                                <v-list>
                                    <template v-for="(player, index) in result.winnerList">
                                        <v-list-tile :key="index" avatar>
                                            <v-list-tile-avatar>
                                                <img :src="thumbs[keyOf(player)]" v-if="thumbs[keyOf(player)]">
                                                <v-icon v-else class="black--text accent">person</v-icon>
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                                <v-list-tile-title v-html="keyOf(player)"
                                                                   style="width: auto"></v-list-tile-title>
                                                <!--                        <v-list-tile-sub-title>choice winner</v-list-tile-sub-title>-->
                                            </v-list-tile-content>

                                            <v-list-tile-action>
                                                <v-chip>
                                                    <v-avatar>
                                                        <img :src="require('../assets/CoinShine_static.gif')"
                                                             style="margin: -1px 0 0 1px">
                                                    </v-avatar>
                                                    {{player[keyOf(player)]}}
                                                </v-chip>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content
                            lazy class="black--text"
                            v-if="result.loserList"
                            :disabled="!result.loserList.length"
                            :key="1">
                        <template v-slot:header>
                            <div>Number of losers: {{result.loserList.length}}</div>
                        </template>
                        <v-card>
                            <v-card-text>
                                <v-list>
                                    <template v-for="(player, index) in result.loserList">
                                        <v-list-tile :key="index" avatar>
                                            <v-list-tile-avatar>
                                                <img :src="thumbs[keyOf(player)]" v-if="thumbs[keyOf(player)]">
                                                <v-icon v-else class="black--text accent">person</v-icon>
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                                <v-list-tile-title v-html="keyOf(player)"
                                                                   style="width: auto"></v-list-tile-title>
                                                <!--                        <v-list-tile-sub-title>choice loser</v-list-tile-sub-title>-->
                                            </v-list-tile-content>

                                            <v-list-tile-action>
                                                <v-chip>
                                                    <v-avatar>
                                                        <img :src="require('../assets/CoinShine_static.gif')"
                                                             style="margin: -1px 0 0 1px">
                                                    </v-avatar>
                                                    {{player[keyOf(player)]}}
                                                </v-chip>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content
                            lazy class="black--text"
                            v-if="result.tieList && result.tieList.length"
                            :key="2">
                        <template v-slot:header>
                            <div>Tie: {{result.tieList.length}}</div>
                        </template>
                        <v-card>
                            <v-card-text>
                                <v-list>
                                    <template v-for="(player, index) in result.tieList">
                                        <v-list-tile :key="index" avatar>
                                            <v-list-tile-avatar>
                                                <img :src="thumbs[keyOf(player)]" v-if="thumbs[keyOf(player)]">
                                                <v-icon v-else class="black--text accent">person</v-icon>
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                                <v-list-tile-title v-html="keyOf(player)"
                                                                   style="width: auto"></v-list-tile-title>
                                                <!--                        <v-list-tile-sub-title></v-list-tile-sub-title>-->
                                            </v-list-tile-content>

                                            <v-list-tile-action>
                                                <v-chip></v-chip>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn round color="warning" @click="close">ok</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex";
    import BracketItem from "@/components/BracketItem";

    export default {
        name: "DeclareWinner",
        components: {BracketItem},
        props: ['instaplay', 'mode'],
        data() {
            return {
                dialog: false,
                step: 1,
                // simple pool line
                contestantId: '',
                // total
                // totalPoints: '',
                // spread
                finalScore: ['', ''],
                panel: [],
                bracketModel: {},
                bracketTie: false
            }
        },
        computed: {
            ...mapGetters('instaplays', ['isLoading', 'isSuccess']),
            ...mapState('thumbnails', ['thumbs']),
            result() {
                return this.$store.state.instaplays.instaplayOutcome[this.instaplay.InstaplayId]
            },
            winner() {
                let w
                if (this.result.winner) {
                    w = this.result.winner
                    return isNaN(w) ? {w: w === 'tie' || w === '0' || w === 0 ? 'Tie' : w} : {
                        w: w === 'tie' || w === '0' || w === 0 ? 'Tie' : this.instaplay['contestant' + w].name,
                        i: w !== '0' && w !== 0 ? this.instaplay['contestant' + w].image : undefined
                    }
                } else if (this.result.submit) {
                    w = this.result.submit
                    if (this.typeIs('pool') || this.typeIs('line') || this.typeIs('simple')) {
                        let x = w.selectedContestantID
                        return {
                            w: x === 'tie' || x === '0' || x === 0 ? 'Tie' : 'Winner: ' + this.instaplay['contestant' + x].name,
                            i: x !== '0' && x !== 0 ? this.instaplay['contestant' + x].image : undefined
                        }
                    } else {
                        let c1 = this.instaplay.contestant1
                        let c2 = this.instaplay.contestant2
                        return {
                            w: c1.name + " " + w.scoreContestant1 + " - "
                                + w.scoreContestant2 + " " + c2.name,
                            i: c2.image,
                            i2: c1.image
                        }
                    }
                }
                return ''
            },
            contestants() {
                let arr = []
                let order = []
                if (this.instaplay.bracket)
                    order = this.instaplay.bracket.order
                else
                    for (let i = 1; i <= this.instaplay.numContestants; i++)
                        order.push[i]
                let index = 1
                for (let i of order) {
                    let obj = {...this.instaplay['contestant' + i], id: i, index}
                    arr.push(obj)
                    index++
                }
                return arr
            },
            typeIs() {
                return (type) => this.instaplay.InstaplayType === type
            },
            valid() {
                return (this.contestantId !== '' || (this.finalScore [0] !== '' && this.finalScore [1] !== ''))
                    || (this.typeIs('bracket') && ( this.bracketTie)) || this.validBracket
            },
            validBracket() {
                let bracket = Object.assign({}, this.bracketModel)
                for (let i = 1; i <= this.instaplay.numContestants; i++)
                    delete bracket[i]
                return Object.values(bracket).every(x=>x)
            }
        },
        methods: {
            ...mapActions('instaplays', ['declareWinner']),
            submitWinner() {
                const payload = {
                    InstaplayId: this.instaplay.InstaplayId,
                    InstaplayType: this.instaplay.InstaplayType
                }
                if (this.typeIs('bracket')) {
                    if (this.bracketTie) {
                        payload['bracket'] = {["0"]: 0}
                    } else {
                        let bracket = Object.assign({}, this.bracketModel)
                        for (let i = 1; i <= this.instaplay.numContestants; i++)
                            delete bracket[i]
                        payload['bracket'] = bracket
                    }
                } else if (this.typeIs('pool') || this.typeIs('line') || this.typeIs('simple')) {
                    payload['selectedContestantID'] = this.contestantId
                } else {
                    payload['scoreContestant1'] = this.finalScore[0]
                    payload['scoreContestant2'] = this.finalScore[1]
                }
                this.declareWinner({payload, mode: this.mode})
                    .then(() => {
                        if (this.isSuccess('declare')) {
                            this.$emit('declared')
                            this.step = 2
                            this.contestantId = ''
                            this.finalScore[0] = ''
                            this.finalScore[1] = ''
                        }
                    })
            },
            open() {
                this.dialog = true
            },
            close() {
                this.dialog = false
            },
            none() {
                this.panel = null
            },
            setStep(step) {
                this.step = step
            },
            keyOf(obj) {
                return Object.keys(obj)[0]
            }
        },
        watch: {
            dialog(val) {
                if (!val) this.none()
            }
        }
    }
</script>

<style scoped>
    .round {
        border-radius: .4rem;
    }
</style>
